import React, { useEffect, useRef } from 'react'

import { runInAction } from 'mobx'
import { observer } from 'mobx-react'

import SuperFilter from '~/client/src/desktop/components/SuperFilter/SuperFilter'
import DesktopEventStore from '~/client/src/desktop/stores/EventStore/DesktopEvents.store'
import FilterResetter from '~/client/src/shared/components/FilterResetter/FilterResetter'
import SuperFilterHandleButton from '~/client/src/shared/components/Filters/SuperFilter/SuperFilterHandleButton'
import { IFilters } from '~/client/src/shared/stores/InitialState'
import { NOOP } from '~/client/src/shared/utils/noop'

import AttachmentFilterStore from './AttachmentFilter.store'

interface IProps {
  store: AttachmentFilterStore
  forceCloseMap: { [filterType: string]: boolean }
  eventsStore: DesktopEventStore
  filters: IFilters
  activeViewId: string
  resetAllFilters: () => void
}

const AttachmentFilter: React.FC<IProps> = observer(
  ({ store, forceCloseMap, filters, activeViewId, resetAllFilters }) => {
    const clearPostEventCallbackRef = useRef<() => void>(NOOP)

    useEffect(() => {
      const { fieldsMap } = filters

      if (forceCloseMap) {
        runInAction(() => {
          Object.keys(fieldsMap).forEach(filterType => {
            if (forceCloseMap[filterType]) {
              fieldsMap[filterType].isFilterShown = false
            }
          })
        })
      }
    }, [forceCloseMap, filters])

    useEffect(() => {
      return () => {
        clearPostEventCallbackRef.current()
      }
    }, [])

    const renderPopups = (): React.ReactNode[] => {
      const storesMap = store.filterStoresByTypeMap
      return Object.keys(storesMap).map(filterType => {
        const filterStore = storesMap[filterType]
        return (
          <SuperFilter
            key={`${filterType}_${activeViewId}`}
            filterStore={filterStore}
          />
        )
      })
    }

    const renderHandleButtons = (): React.ReactNode[] => {
      const storesMap = store.filterStoresByTypeMap
      return Object.keys(storesMap).map(filterType => {
        const filterStore = storesMap[filterType]
        return (
          <SuperFilterHandleButton
            className="no-grow"
            key={`${filterType}_${activeViewId}`}
            filterStore={filterStore}
            hasIndent={false}
            shouldRenderRightIcon
          />
        )
      })
    }

    const renderReset = (): React.ReactNode => {
      return <FilterResetter onReset={resetAllFilters} />
    }

    return (
      <div className="row full-height location-filter x-start ml8">
        {renderHandleButtons()}
        {renderReset()}
        {renderPopups()}
      </div>
    )
  },
)

export default AttachmentFilter
